<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                        cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >
                      <div v-if="guide">
                        <h1 class="mt-6 mb-6">{{ guide.heading }}</h1>
                        <h2>{{ guide.sub_heading }}</h2>
                        <vimeo-player v-if="guide.video_id" ref="player" :video-id="guide.video_id" @ready="onReady" class="player-container mt-6 mb-6" :options="options">
                        </vimeo-player>
                        <div v-html="guide.copy"></div>
                        <div class="d-flex justify-space-between">
                          <v-btn text icon color="primary" @click="navigate('how-it-works')">
                            <v-icon>mdi-arrow-left</v-icon>
                          </v-btn>
                          <v-btn v-if="guide.cta_route" rounded elevation="0" color="primary" class="mr-3 mb-3" @click="navigate(guide.cta_route)">
                            {{ guide.cta_text }}
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import axios from "axios";
    import {mapState} from "vuex";

    export default {
        name: "Guide",
        metaInfo () {
            return {
                title: this.capitalizeFirstLetter(this.brand) + ' - ' + `${this.title}`,
                htmlAttrs: {
                    lang: i18n.locale
                },
                meta: [
                    { name: 'description', content: `${this.description}` }
                ]
            }
        },
        components: {
            'Footer': Footer
        },
        props: ['slug'],
        data () {
            return {
                guide: null,
                videoID: null,
                title: '',
                description: '',
                content: '',
                height: 1000,
                options: {'responsive': true, 'dnt': true},
                playerReady: false
            }
        },
        watch: {
          '$i18n.locale': function () {
            window.scrollTo(0,0);
            this.loadGuide()
          }
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        mounted () {

            window.scrollTo(0,0);

            this.loadGuide()

            window.prerenderReady = true;
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            },
            loadGuide() {

              this.loading = true
              this.guide = null

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': i18n.locale}
              });

              instance
                  .get('/api/guides/slug/' + this.slug)
                  .then(response => {
                    console.log(response.data.data)
                    this.guide = response.data.data
                  })
                  .catch(error => {
                    console.log(error)
                  })
            },
            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            stop () {
                this.$refs.player.stop()
            },
        }
    }
</script>

<style>

    .product-card {
        border-radius: 15px;
        border: none !important;
    }

    .ql-align-center {
      text-align: center !important;
    }

</style>
